'use client';

import { Box, Flex, Link, Image } from "@chakra-ui/react";
import { useEffect } from 'react';
import { InnerHtml } from "@/components/partials/Helpers";
import analytics from "@/lib/analytics";
import AdSlot from "@/components/AdSlot";

export default function Advertising({ ads, padding = '0' }) {
  if(!ads) return;
  if(Array.isArray(ads) && ads.length > 0) ads = ads[0];
  if(!ads?.advertisement) return;

  ads = ads.advertisement;

  useEffect(() => {
    if(ads?.advToken) {
      analytics('view', ads.advToken);
    };
  }, []);

  return (
    ads && (
      <Flex padding={padding} justifyContent="center">
        { ads.advType === 'admanager' ? (
          <AdSlot token={ads.advToken} location={ads.advLocation} slot={ads.advAdManager} />
        ) : ads.advType === 'tag' ? (
          <Box className={ads.advToken} overflow="hidden">
            <InnerHtml html={ads.advInnerCode} />
          </Box>
        ) : (
          ads.advImage && ads.advImage.length ? (
            <Link href={ads.advEndpoint} title="Publicidade" target="_blank" onClick={() => analytics('click', ads.advToken)}>
              <Image
                src={ads.advImage}
                alt="Publicidade"
                className={ads.advToken}
              />
            </Link>
          ) : null
        )}
      </Flex>
    )
  )
}
